<template>
    <div class="wrapping">
      <div class="item-title">
        <p v-if="props.translate">会社概要</p>
        <p v-else>Company Profile</p>
      </div>

      <div v-if="props.translate" class="item-detail">
        <p class="ttl">会社名</p>
        <p>株式会社クープデザイン</p>
        <p>Coupe Design Co., Ltd.</p>
        <p class="ttl">所在地</p>
        <p>104-0061</p>
        <p>東京都中央区銀座1-16-7</p>
        <p>銀座大栄ビル6階(受付5階)</p>
        <p class="ttl">電話</p>
        <p aria-label="0343608675">03-4360-8675</p>
        <p class="ttl">代表者</p>
        <p>代表取締役社長 保科里佳</p>
        <p class="ttl">設立</p>
        <p>2024年7月</p>
        <p class="ttl">取引銀行</p>
        <p>三菱UFJ銀行 京橋支店</p>
      </div>
      <div v-else class="item-detail">
        <p class="ttl">Trade name</p>
        <p>Coupe Design Co., Ltd.</p>
        <p>株式会社クープデザイン</p>
        <p class="ttl">Office location</p>
        <p>Daiei Ginza Building, 6th Floor (Reception on 5th Floor),<br class="is-pc">
        1-16-7, Ginza, Chuo-ku, Tokyo, 104-0061, Japan</p>
        <p class="ttl">Phone</p>
        <p>+81-3-4360-8675</p>
        <p class="ttl">Representative</p>
        <p>Representative Director and President</p>
        <p>Rika Hoshina</p>
        <p class="ttl">Established</p>
        <p>July 2024</p>
        <p class="ttl">Customer Bank</p>
        <p>MUFG Bank, Ltd. Kyobashi Branch.</p>
      </div>
    </div>
</template>
  
<script lang="ts" setup>
const props = defineProps(['translate']) 

</script>

<style scoped>
.wrapping {
  position: absolute;
  left: 0;
  width: 100%;
  margin: 20px 0;
  background-color: #f9f9f9;
  opacity: 0.9;
}
.item-title {
  color: #f9ffff;
  font-size: 1.1rem;
  text-align: center;
  background-color: #2c3e50;
  margin-top: 15px;
  padding: 5px;
  opacity: 0.7;
}
.item-detail {
  padding: 0px 0 15px 55px;
}
.img-mtg {
  margin: 10px;
  text-align: left;
}
.img-mtg img {
  height: 100px;
}
.img-dev {
  margin: 20px;
  text-align: center;
}
.img-staff :hover {
  opacity: 0.5;
}
p{
  margin: 0;
}
p.ttl{
  font-weight: bold;
  margin: 10px 0 2px;
}
@media (max-width: 667px) {
  .is-pc {
    display: none;
  }
  .item-detail {
    padding: 0px 0 15px 55px;
  }
  p.ttl{
    font-weight: bold;
    margin: 10px 0 3px;
  }
}
</style>
  